import React from 'react';
import Title from './Title';
import { componentMap } from './compMapping';

export default function ItemList({ details }) {
  return (
    <div
      css={`
        border-radius: ${details?.border_radius || '5px'};
        display: flex;
        flex-direction: ${details?.orientation === 'vertical'
          ? 'column'
          : 'row'};
        gap: ${details?.gap || '1rem'};
        width: ${details?.width || '100%'};
      `}
    >
      {details?.children.length > 0 &&
        details?.children.map((child) => {
          let CompName = '';
          if (child.type in componentMap)
            CompName = componentMap[`${child.type}`];
          else return '';
          return <CompName details={child} />;
        })}
    </div>
  );
}
